import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          漫画爱好者最关注的热门讨论话题
        </p>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicItems.map((item, i) => {
            const colors = [
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-50 text-primary-600 hover:bg-primary-100',
              'bg-accent-50 text-accent-600 hover:bg-accent-100',
              'bg-secondary-50 text-secondary-600 hover:bg-secondary-100',
              'bg-primary-100 text-primary-700 hover:bg-primary-200',
              'bg-accent-100 text-accent-700 hover:bg-accent-200',
              'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
              'bg-primary-50 text-primary-600 hover:bg-primary-100',
            ];
            return (
              <a
                key={i}
                href="#ranking"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${colors[i]}`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-current opacity-40" />
                <span>{item.name}</span>
                <span className="text-xs opacity-60">{item.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}